import { useEffect, useRef, useState } from "react";

import {
  SelectCountryModal,
  SelectCountryModalSheet,
  TravellingToWidget,
} from "../../components";
import DescriptionModal from "../DescriptionModal/DescriptionModal";
import PopularCountryComp from "./PopularCountryCompV2";
import UpcomingTrips from "./UpcomingTrips";

import { getAnalytics } from "@tm/insurance/analytics";
import { navigationActionsSeo } from "@tm/insurance/navigation";
import {
  convertDateToUnix,
  getCookieByName,
  getPartnerOnClientSide,
  replaceHistory,
  replaceHistoryRemoveParams,
} from "@tm/insurance/utils";
import { PARTNER, RESPONSE_STATUS, STORAGE_KEYS } from "@tm/isomorphic-utils";
import { useBreakpointV2 } from "@tm/ui-widgets";
import {
  AnchorTag,
  CommonModalDweb,
  FlexComp,
  FormattedText,
  H5Tag,
  LandingButton,
  ParaTag,
  SectionDividers,
  SpanTag,
  Tags,
  WebToast,
} from "@tm/ui-widgets/components";
import { usePartnerContext } from "@tm/ui-widgets/hooks";
import {
  ClientError,
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem,
} from "@tm/utility";
import { theme } from "@tm/utility/global";

import { ITravellingTo } from "./types";

import { trackComponentView, trackEvent } from "@tm/insurance/analytics/xdm";
import { getNextPageRouteDetails } from "@tm/insurance/api";
import { AxiosError } from "axios";
import { errorTrackEvent } from "libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents";
import {
  DiscountingNote,
  TravellingToStyle,
  TravellingToStyleWrap,
  TravelNote,
} from "./TravelDetails.style";

const analytics = getAnalytics();

const TravellingTo = ({
  travellingToSection,
  upcomingTrip,
  calendarDatesLimit,
  travelSearchBanner,
  btnDisabledState = true,
  nextPageRoute,
  countryCodes,
  setLoginModal,
}: ITravellingTo) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const device = useBreakpointV2();
  const context = usePartnerContext();

  const {
    otherCountryTxt,
    travelNote,
    travDateTitle,
    travCountTitle,
    travPurpTitle,
    travelPurposeTxt,
    popularCountryTxt,
    travelBtnTxt,
    travelSearchForm,
  } = travellingToSection || {};

  const { label, error_message, countrySelectErrMsg, placeHolder, value } =
    travelSearchForm.regionCountryList;

  const [popularCountries, setPopularCountries] = useState<any[]>([]);
  const [countryData, setCountryData] = useState<any[]>([]);
  const [showOtherCountry, setOtherCountry] = useState(false);
  const [countValue, setCountValue] = useState<number>(0);
  const [calenderValue, setCalenderValue] = useState<any>();
  const [showCountry, setShowCountry] = useState<any>([]);
  const [isCountryError, setIsCountryError] = useState(false);
  const [descriptionTxt, setDescriptionTxt] = useState<string>("");
  const [isSelectedError, setIsSelectedError] = useState<boolean>(false);
  const [descTitle, setDescTitle] = useState<string>("");
  const [segments, setSegments] = useState<any[]>([]);
  const [segmentSelected, setSegmentSelected] = useState<any>({});
  const [isSegmentModalShown, setIsSegmentModalShown] = useState(false);
  const [countrySelectToastMsg, setCountrySelectToastMsg] = useState("");
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [nextPageError, setNextPageError] = useState<AxiosError>();

  //set the default selected segement
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam = queryParams.get("segment");
    const segments = travelSearchForm?.segments?.value;

    if (segments) {
      const segment = segments.find(
        (item) => item.id === segParam || (!segParam && item.isSelected)
      );
      if (segment) {
        setSegmentSelected(segment);
        replaceHistory("segment", segment.id);
      }
    }
  }, []);

  //set the travelSerachForm.segments to segments
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam = queryParams.get("segment");

    if (travelSearchForm?.segments?.value) {
      if (segParam) {
        handleSegementSelect(segParam);
      } else {
        setSegments(travelSearchForm?.segments?.value);
      }
    }
  }, [travelSearchForm?.segments]);

  useEffect(() => {
    if (travelSearchForm?.segments) {
      analytics?.trackLandingEvents(
        {
          actionType: "special_segments_shown",
        }
        //"click"
      );
      trackComponentView({
        name: "special_segments_shown",
        type: "card",
      });
    }
  }, [travelSearchForm?.segments]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const selectedCountries = queryParams.get("countries") || countryCodes;
    let selectedCountryCodes: string | string[] | undefined;

    if (selectedCountries) {
      selectedCountryCodes = selectedCountries?.split(",");
    } else if (upcomingTrip?.countryCode) {
      selectedCountryCodes = upcomingTrip?.countryCode;
      replaceHistory("countries", upcomingTrip?.countryCode);
    }
    let totalCountryData = value?.map((data: any) => {
      if (selectedCountryCodes?.includes(data.code)) {
        return { ...data, isSelected: true };
      }
      return { ...data };
    });
    const isExclusiveCountrySelected = totalCountryData?.find(
      (item: any) => item.isExclusiveSelection && item.isSelected
    );
    totalCountryData = totalCountryData?.map((country: any) => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection
          ? { ...country }
          : { ...country, isSelected: false, isDisabled: true };
      } else if (totalCountryData.some((item: any) => item.isSelected)) {
        return country.isExclusiveSelection
          ? { ...country, isDisabled: true }
          : { ...country };
      }
      return { ...country };
    });
    const selectedRegionCodes = totalCountryData
      ?.filter((data: any) => data.isSelected && data.type === "REGION")
      ?.map((data: any) => data.code);

    selectedRegionCodes?.map((code: string) => {
      totalCountryData = totalCountryData?.map((country: any) => {
        if (country.regionCodes && country.regionCodes.includes(code)) {
          return { ...country, isDisabled: true };
        }
        return { ...country };
      });
    });
    setCountryData(totalCountryData);
    let popularCountryData =
      totalCountryData?.filter(
        (country: any) => country.isSelected || country.isPopular
      ) ?? [];

    popularCountryData = [
      ...popularCountryData?.filter(
        (country: any) => country.isSelected && !country.isDisabled
      ),
      ...popularCountryData?.filter((country: any) => country.isDisabled),
      ...popularCountryData.filter(
        (country: any) => !country.isSelected && !country.isDisabled
      ),
    ];
    setShowCountry([...popularCountryData]);
    setPopularCountries([...popularCountryData]);
  }, [value, upcomingTrip, travelSearchForm.segments]);

  useEffect(() => {
    const button = buttonRef.current;
    let viewportMargin = 16;
    let searchBarOffset = 60;

    if (button) {
      const rect = button.getBoundingClientRect();
      const offsetTop = window.scrollY + rect.top;

      const isInViewport =
        offsetTop >= 0 &&
        offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        const scrollPosition =
          offsetTop -
          window.innerHeight +
          rect.height +
          viewportMargin +
          searchBarOffset;
        window.scrollTo({ top: scrollPosition, behavior: "smooth" });
      }
    }
  }, [showCountry]);

  const populateTravelDetails = (
    countryCodes: any,
    startDate?: string,
    endDate?: string,
    travellers?: string
  ) => {
    if (countryCodes) {
      replaceHistory("countries", countryCodes);
    }
    if (startDate) {
      replaceHistory("startDate", startDate);
    }
    if (endDate) {
      replaceHistory("endDate", endDate);
    }
    if (travellers) {
      replaceHistory("travellers", travellers);
    }
  };

  const handleUpcomingTripClick = () => {
    replaceHistory("isUpcomingTrip", "true");
    removeSessionStorageItem(STORAGE_KEYS.TRAVELLER_DETAILS);

    analytics?.trackLandingEvents(
      {
        actionType: "upcoming_trips_clicked",
      }
      //"click"
    );
    trackEvent({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upcoming_trips_clicked",
      },
    });

    const { countryCode, travelDuration, travellerNum } = upcomingTrip || {};

    const selectedCountry = countryData?.find(
      (country: any) => country.code === countryCode
    );

    populateTravelDetails(
      selectedCountry?.code,
      travelDuration?.startDate?.toString(),
      travelDuration?.endDate?.toString(),
      travellerNum?.toString()
    );

    if (nextPageRoute) {
      navigationActionsSeo.navigateToPageByRouteName(
        `${nextPageRoute}&isUpcomingTrip=true`
      );
    } else {
      const data = {
        startDate: travelDuration?.startDate?.toString(),
        endDate: travelDuration?.endDate?.toString(),
        travellers: travellerNum?.toString?.(),
        countries: [countryCode],
        isUpcomingTrip: true,
      };
      navigationActionsSeo.navigateToListing(data);
    }
  };

  const handleShowOtherCountry = () => {
    if (!showOtherCountry) {
      let countryDataArr = countryData?.map((country: any) => {
        return { ...country, isSelected: false, isDisabled: false };
      });
      popularCountries.map((data: any) => {
        countryDataArr = countryDataArr?.map((country: any) => {
          if (country.code === data.code) {
            return {
              ...country,
              isSelected: data.isSelected,
            };
          }
          return { ...country };
        });
      });
      const isExclusiveCountrySelected = countryDataArr.find(
        (item: any) => item.isExclusiveSelection && item.isSelected
      );
      countryDataArr = countryDataArr?.map((country: any) => {
        if (isExclusiveCountrySelected) {
          return country.isExclusiveSelection
            ? { ...country }
            : { ...country, isSelected: false, isDisabled: true };
        } else if (countryDataArr.some((item: any) => item.isSelected)) {
          return country.isExclusiveSelection
            ? { ...country, isDisabled: true }
            : { ...country };
        }
        return { ...country };
      });
      const selectedRegionCodes = countryDataArr
        .filter((data: any) => data.isSelected && data.type === "REGION")
        .map((data: any) => data.code);

      selectedRegionCodes?.map((code: string) => {
        countryDataArr = countryDataArr.map((country: any) => {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return { ...country, isDisabled: true };
          }
          return { ...country };
        });
      });
      setCountryData(countryDataArr);
    }
    setOtherCountry(!showOtherCountry);
  };

  const handleDescriptionModal = (country: any) => {
    const clickedTime = getSessionStorageItem("clickedTime")
      ? getSessionStorageItem("clickedTime")
      : {};
    const currentTime = new Date().getTime();
    const code = country.code;
    if (
      !clickedTime[country.code] ||
      currentTime - parseInt(clickedTime[country.code], 10) >= 1800000
    ) {
      clickedTime[code] = currentTime.toString();
      setSessionStorageItem("clickedTime", {
        ...clickedTime,
      });
      return country.description;
    }
    return "";
  };

  const handlePopularCountrySelect = (code: string) => {
    setIsCountryError(false);
    let popularCountryArr = popularCountries?.map((country: any) => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return { ...country };
        }
        if (country.type === "REGION") {
          setDescriptionTxt(handleDescriptionModal(country));
          setDescTitle(country.descTitle);
        }
        return { ...country, isSelected: true, isDisabled: false };
      }
      return { ...country, isDisabled: false };
    });

    const isExclusiveCountrySelected = popularCountryArr.find(
      (item: any) => item.isExclusiveSelection && item.isSelected
    );

    popularCountryArr = popularCountryArr.map((country: any) => {
      if (isExclusiveCountrySelected) {
        return !country.isExclusiveSelection
          ? { ...country, isSelected: false, isDisabled: true }
          : { ...country };
      } else if (popularCountryArr.some((item: any) => item.isSelected)) {
        return country.isExclusiveSelection
          ? { ...country, isDisabled: true }
          : { ...country };
      }
      return { ...country };
    });

    const selectedPopRegionCodes = popularCountryArr
      .filter((country: any) => country.isSelected && country.type === "REGION")
      .map((country: any) => {
        return country.code;
      });

    selectedPopRegionCodes.map((item: any) => {
      popularCountryArr = popularCountryArr.map((country: any) => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return { ...country, isDisabled: true };
        }
        return { ...country };
      });
    });

    const selectedCountries = popularCountryArr.filter(
      (country: any) => country.isSelected && !country.isDisabled
    );

    trackEvent(
      {
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "sco:popular_country_selected",
        },
      },
      {
        countries: selectedCountries,
      }
    );

    setPopularCountries(popularCountryArr);
    setShowCountry(popularCountryArr);
    const countries: string = popularCountryArr
      .filter((data: any) => data.isSelected && !data.isDisabled)
      .map((data: any) => data.code)
      .join(",");
    if (countries) {
      replaceHistory("countries", countries);
    } else {
      replaceHistoryRemoveParams("countries");
    }
  };

  const handleSegementSelect = (segmentId?: string | number) => {
    if (travelSearchForm?.segments?.value) {
      let updatedData = travelSearchForm?.segments?.value.map((item) => {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          replaceHistory("segment", item.id);
        } else {
          item.isSelected = false;
        }
        return item;
      });
      setSegments(updatedData);
    }
  };

  const handleSegmentClick = (segmentId?: string | number) => {
    trackEvent(
      {
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "sco:segment_clicked",
        },
      },
      {
        journeyType: segmentId?.toString().toLowerCase() || "",
      }
    );

    if (travelSearchForm?.segments?.value) {
      let updatedData = travelSearchForm?.segments?.value.map((item) => {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          replaceHistory("segment", item.id);
          analytics?.trackLandingEvents(
            {
              actionType: item.config.clickEventName,
            }
            //"click"
          );
        } else {
          item.isSelected = false;
        }
        return item;
      });
      setSegments(updatedData);
    }
  };

  let toastTimeout: NodeJS.Timeout | null = null;

  const toggleSegmentModal = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const countryCodes = countries?.split(",");
    if (!countryCodes) {
      setIsCountryError(true);
    } else if (countryCodes[0] == "IN" && segmentSelected?.id === "STUDENT") {
      setCountrySelectToastMsg(
        "We do not have domestic student plans, please select another country to see student plans"
      );
      if (toastTimeout) clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => {
        setCountrySelectToastMsg("");
      }, 2000);
    } else {
      segmentSelected?.modal && setIsSegmentModalShown(true);
    }
  };

  const onSubmit = async () => {
    const searchParams = new URLSearchParams(window.location.search);

    const countries = searchParams.get("countries");
    const isUpcomingTrip = searchParams.get("isUpcomingTrip");

    let countryCodes = countries?.split(",");

    // If no countries in URL, check the state for selected countries
    if (!countryCodes) {
      const selectedCountriesFromState = showCountry
        ?.filter((country: any) => country.isSelected && !country.isDisabled)
        ?.map((country: any) => country.code);

      if (selectedCountriesFromState?.length > 0) {
        countryCodes = selectedCountriesFromState;
        // Update URL with selected countries from state
        replaceHistory("countries", selectedCountriesFromState.join(","));
        // Clear any existing country error since we found selected countries
        setIsCountryError(false);
      }
    }

    if (!countryCodes || countryCodes.length === 0) {
      setIsCountryError(true);
      analytics?.trackLandingEvents(
        {
          actionType: "error_shown",
          payload: error_message,
        }
        //"click"
      );
      errorTrackEvent({
        error_details_list: [
          {
            message: error_message,
            source: "country_select",
            severity: 3,
          },
        ],
      });
      return; // Don't proceed with API call if no countries are selected
    } else {
      // Clear error if we have countries
      setIsCountryError(false);
    }

    if (isUpcomingTrip) {
      replaceHistoryRemoveParams("isUpcomingTrip");
      searchParams.delete("isUpcomingTrip");
      removeSessionStorageItem(STORAGE_KEYS.TRAVELLER_DETAILS);
    }

    replaceHistory("segment", segmentSelected?.id);

    if (calenderValue && countValue && countryCodes?.length) {
      const selectedPopCountries = (popularCountries ?? [])
        .filter((country) => countryCodes?.includes(country.code))
        .map((item) => item.name)
        .join("|");

      analytics?.trackLandingEvents(
        {
          actionType: "popular_country_selected",
          payload: selectedPopCountries,
        }

        //"click"
      );

      const queryParams = Object.fromEntries(searchParams.entries());

      const params = {
        ...queryParams,
        startDate: convertDateToUnix(calenderValue.from).toString(),
        endDate: calenderValue.to
          ? convertDateToUnix(calenderValue.to).toString()
          : searchParams.get("endDate"),
        travellers: countValue,
        countries: countryCodes,
        segment: segmentSelected?.id,
      };

      analytics?.trackLandingEvents(
        {
          actionType: "explore_plan_click",
        }
        //"click"
      );

      trackEvent({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "explore_plan_click",
        },
      });

      const partner = getPartnerOnClientSide();
      const requestData = {
        query: { source: "seo" },
        partner,
        userSearchIntent: {
          country: countryCodes,
          departureDateTime: convertDateToUnix(calenderValue.from),
          arrivalDateTime: calenderValue.to
            ? convertDateToUnix(calenderValue.to)
            : Number(searchParams.get("endDate")),
          numberOfTravellers: countValue,
          segment: segmentSelected?.id,
        },
      };

      try {
        const response = await getNextPageRouteDetails(requestData);
        const { responseStatus, nextPageRouteConfig } = response;

        if (responseStatus === RESPONSE_STATUS.SUCCESS) {
          navigationActionsSeo.navigateToPageByRouteName(
            `${nextPageRouteConfig?.route}`
          );
        }
      } catch (error: any) {
        console.error("NEXT PAGE ROUTE FAILURE ERROR ----", {
          error: error?.response,
        });
        if (error?.response?.status === 401) {
          const domain =
            partner === PARTNER.GI ? ".goibibo.com" : ".makemytrip.com";
          if (getCookieByName("next_page_req")) {
            document.cookie = `next_page_req=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/`;
          }
          document.cookie = `next_page_req= ${JSON.stringify(
            requestData
          )}; expires=${new Date(
            Date.now() + 15 * 60 * 1000
          ).toUTCString()}; domain=${domain}; path=/`;
          if (device === "sm" && partner === PARTNER.MMT) {
            const host = window.location.host;
            const req = {
              url: window.location.pathname + window.location.search,
            };
            document.cookie =
              "loginActionDetails=" +
              JSON.stringify(`https://${host}/insurance/next-page`) +
              ";domain=.makemytrip.com;path=/";
            window.location.href =
              "https://www.makemytrip.com/pwa/hlp/v3/login";
          }
          setLoginModal?.("LOGIN");
        } else {
          setNextPageError(error?.response);
        }
      }
    }
  };

  const isExclusiveCountrySelected = countryData.find(
    (item: any) => item.isExclusiveSelection && item.isSelected
  );

  if (nextPageError && typeof window !== "undefined") {
    throw new ClientError(nextPageError);
  }

  return (
    <TravellingToStyleWrap>
      {travelSearchBanner ? (
        <DiscountingNote pageTheme={context ? context : "mmt"}>
          {travelSearchBanner?.icon && (
            <img
              width="24px"
              height="24px"
              src={travelSearchBanner?.icon}
              style={{
                animation: "rotate 2s linear infinite",
              }}
              loading="eager"
            />
          )}
          <FlexComp
            flexDirection={device === "sm" ? "column" : "row"}
            margin="0px 0px 0px 4px"
            gap={device === "lg" ? "4px" : "0px"}
          >
            {travelSearchBanner?.title && (
              <FormattedText
                value={travelSearchBanner?.title}
                baseStyle={{
                  fontWeight: "bold",
                  fontSize: device === "lg" ? "16px" : "12px",
                  color: theme.greenText5,
                }}
              />
            )}
            {travelSearchBanner?.description && (
              <FormattedText
                value={travelSearchBanner?.description}
                baseStyle={{
                  fontWeight: "regular",
                  fontSize: device === "lg" ? "14px" : "12px",
                  marginTop: device === "lg" ? "2px" : "0px",
                  color: theme.greenText5,
                }}
              />
            )}
          </FlexComp>
        </DiscountingNote>
      ) : (
        <TravelNote pageTheme={context ? context : "mmt"}>
          <FormattedText value={travelNote} />
        </TravelNote>
      )}

      <TravellingToStyle>
        <H5Tag color={theme.blackText}>
          <FormattedText value={label} />
        </H5Tag>
        <ParaTag margin="0px 0px 20px 0px">
          <FormattedText value={placeHolder} baseStyle={{ color: "#717171" }} />
        </ParaTag>

        {upcomingTrip && (
          <UpcomingTrips
            country={upcomingTrip?.country}
            countryCode={upcomingTrip?.countryCode}
            travelDuration={upcomingTrip?.travelDuration}
            travellerNum={upcomingTrip?.travellerNum}
            travellerTitle={upcomingTrip?.travellerTitle}
            handleUpcomingTripClick={handleUpcomingTripClick}
          />
        )}

        <SpanTag
          color={theme.greyText7}
          fontWeight="bold"
          fontSize="xs"
          margin="2px 0 8px"
        >
          {popularCountryTxt && <FormattedText value={"Popular Destination"} />}
        </SpanTag>

        <PopularCountryComp
          otherCountryTxt={otherCountryTxt}
          handleShowOtherCountry={handleShowOtherCountry}
          popCountry={showCountry}
          setIsSelectedError={setIsSelectedError}
          setCountrySelectToastMsg={setCountrySelectToastMsg}
          handlePopularCountrySelect={handlePopularCountrySelect}
        />

        {isCountryError && (
          <ParaTag
            color={theme.redText2}
            fontSize="xs"
            margin={device === "sm" ? "0 0 8px" : "8px 0 0"}
          >
            {error_message}
          </ParaTag>
        )}

        {device == "lg" && (
          <SectionDividers
            margin="14px -30px 14px"
            backgroundColor={"#FFFFFF"}
            xs
          />
        )}
        <TravellingToWidget
          travelPurposeTxt={travelPurposeTxt}
          travCountTitle={travCountTitle}
          travPurpTitle={travPurpTitle}
          travDateTitle={travDateTitle}
          btnDisabledState={btnDisabledState}
          setCountValue={setCountValue}
          calendarDatesLimit={calendarDatesLimit}
          setCalenderValue={setCalenderValue}
          upcomingTravellerNum={upcomingTrip?.travellerNum}
          upcomingFromDate={upcomingTrip?.travelDuration?.startDate}
          upcomingToDate={upcomingTrip?.travelDuration?.endDate}
          calendarConfig={
            isExclusiveCountrySelected?.config?.calendar ||
            segmentSelected?.config ||
            calendarDatesLimit
          }
        />
        {travelSearchForm?.segments && (
          <FlexComp margin="0 0 24px" gap="8px" flexDirection="column">
            <ParaTag
              fontSize="xs"
              fontWeight="bold"
              textTransform="uppercase"
              color={theme.greyText}
            >
              {travelSearchForm?.segments?.label}
            </ParaTag>
            <Tags
              handleClickTab={handleSegmentClick}
              data={travelSearchForm?.segments?.value}
            />
          </FlexComp>
        )}

        {isSegmentModalShown && segmentSelected && segmentSelected?.modal && (
          <CommonModalDweb
            customIcon={segmentSelected?.modal?.icon}
            customTitle={segmentSelected?.modal?.title}
            handleClick={() => {
              setIsSegmentModalShown(false);
            }}
            nonClipHeading
          >
            <ParaTag fontSize="md" color={theme.greyText} margin="0 0 36px">
              <FormattedText value={segmentSelected?.modal?.description} />
            </ParaTag>
            <FlexComp justifyContent="space-between" alignItems="center">
              <AnchorTag
                handleClick={() => {
                  setIsSegmentModalShown(false);
                }}
                fontSize="md"
                fontWeight="bold"
              >
                <FormattedText
                  value={segmentSelected?.modal?.secondaryCtaText}
                />
              </AnchorTag>
              <AnchorTag
                handleClick={() => {
                  setIsSegmentModalShown(false);
                  onSubmit();
                }}
                fontSize="md"
                fontWeight="bold"
              >
                <FormattedText value={segmentSelected?.modal?.primaryCtaText} />
              </AnchorTag>
            </FlexComp>
          </CommonModalDweb>
        )}

        {travelBtnTxt && (
          <LandingButton
            buttonref={buttonRef}
            customWidth="100%"
            customTitle={travelBtnTxt}
            onClick={
              segmentSelected?.modal && travelSearchForm?.segments
                ? toggleSegmentModal
                : onSubmit
            }
          />
        )}

        <ParaTag color={theme.greyText} margin="16px 0 0">
          {travelSearchForm?.disclaimer}
        </ParaTag>

        {showOtherCountry && device == "lg" && (
          <SelectCountryModal
            countryData={countryData}
            handleSelectCountry={handleShowOtherCountry}
            setCountryData={setCountryData}
            setShowCountry={setShowCountry}
            showCountry={showCountry}
            setIsCountryError={setIsCountryError}
            popularCountries={popularCountries}
            setPopularCountries={setPopularCountries}
            customSubTitle={placeHolder}
            countrySelectErrMsg={countrySelectErrMsg}
            handleDescriptionModal={handleDescriptionModal}
          />
        )}

        {showOtherCountry && device == "sm" && (
          <SelectCountryModalSheet
            countryData={countryData}
            showCountry={showCountry}
            handleSelectCountry={handleShowOtherCountry}
            setCountryData={setCountryData}
            setShowCountry={setShowCountry}
            setIsCountryError={setIsCountryError}
            popularCountries={popularCountries}
            setPopularCountries={setPopularCountries}
            customSubTitle={placeHolder}
            countrySelectErrMsg={countrySelectErrMsg}
            handleDescriptionModal={handleDescriptionModal}
          />
        )}

        {descriptionTxt && (
          <DescriptionModal
            handleDescriptionModal={() => setDescriptionTxt("")}
            value={descriptionTxt}
            title={descTitle}
          />
        )}

        {isSelectedError && device === "lg" && (
          <WebToast
            toastTxt={countrySelectErrMsg}
            position="fixed"
            height="46px"
            width="320px"
            bottom="100px"
            right="50px"
          />
        )}

        {isSelectedError && device === "sm" && (
          <WebToast
            toastTxt={countrySelectErrMsg}
            position="fixed"
            height="40px"
            bottom="10px"
          />
        )}
        {countrySelectToastMsg && (
          <WebToast
            toastTxt={countrySelectToastMsg}
            position="fixed"
            height="46px"
            width="320px"
            bottom="100px"
            right="50px"
          />
        )}
      </TravellingToStyle>
    </TravellingToStyleWrap>
  );
};

export default TravellingTo;
